<div class="red-backdrop" (click)="close()"></div>
<div class="red-dialog" role="dialog" aria-modal="true" [attr.aria-label]="isOrganizer ? 'Edit registration' : 'Edit your registration'">
    <div class="red-head">
        <div>
            <h5 class="mb-0">{{ isOrganizer ? 'Edit registration' : 'Edit your registration' }}</h5>
            <small class="text-muted" *ngIf="registrantName">{{ registrantName }} · {{ event?.title }}</small>
            <small class="text-muted" *ngIf="!registrantName">{{ event?.title }}</small>
        </div>
        <button type="button" class="red-x" aria-label="Close" (click)="close()">&times;</button>
    </div>

    <div class="red-body">
        <!-- Money summary -->
        <div class="red-money">
            <div><span>Amount due</span><strong>{{ amountDue | currency:'USD' }}</strong></div>
            <div><span>Paid</span><strong>{{ amountPaid | currency:'USD' }}</strong></div>
            <div [class.red-due]="amountDue - amountPaid > 0.004" [class.red-over]="amountDue - amountPaid < -0.004">
                <span>Balance</span><strong>{{ (amountDue - amountPaid) | currency:'USD' }}</strong>
            </div>
        </div>
        <p class="small text-muted mb-3" *ngIf="isConfirmed">
            This registration is confirmed. Changes keep it confirmed; any difference is shown as a balance to pay
            (or an overpayment the organizers will refund).
            <span *ngIf="isOrganizer">To make changes before confirming again, enter a reason and choose "Move back to pending".</span>
        </p>

        <!-- CONFERENCE: ticket options -->
        <div *ngIf="isConference">
            <h6>Tickets</h6>
            <div class="red-row" *ngFor="let o of ticketOptions; trackBy: trackById">
                <div class="red-row-label">
                    <span *ngIf="o.sectionLabel" class="text-muted small">{{ o.sectionLabel }} · </span>{{ o.label }}
                    <span *ngIf="o.required" class="text-danger" title="Required">*</span>
                    <small class="d-block text-muted" *ngIf="o.subText">{{ o.subText }}</small>
                </div>
                <div class="red-row-price" *ngIf="o.paid !== false">{{ +o.price | currency:'USD' }}</div>
                <div class="red-row-price text-muted" *ngIf="o.paid === false">&mdash;</div>
                <input type="number" min="0" class="form-control form-control-sm red-qty"
                       [ngModel]="quantities[o.optionId!] || 0" (ngModelChange)="setQuantity(o.optionId!, $event)"
                       [ngModelOptions]="{standalone: true}" [attr.aria-label]="o.label + ' quantity'">
            </div>
        </div>

        <!-- LOCAL: head-count -->
        <div *ngIf="!isConference">
            <h6>Attendees</h6>
            <div class="red-row">
                <div class="red-row-label">Adults</div>
                <div class="red-row-price" *ngIf="isPaidLocal">{{ +(event.eventFeeAdult || 0) | currency:'USD' }}</div>
                <input type="number" min="0" class="form-control form-control-sm red-qty" [(ngModel)]="adults"
                       [ngModelOptions]="{standalone: true}" aria-label="Adults">
            </div>
            <div class="red-row">
                <div class="red-row-label">Children</div>
                <div class="red-row-price" *ngIf="isPaidLocal">{{ +(event.eventFeeChild || 0) | currency:'USD' }}</div>
                <input type="number" min="0" class="form-control form-control-sm red-qty" [(ngModel)]="children"
                       [ngModelOptions]="{standalone: true}" aria-label="Children">
            </div>
            <div class="red-row">
                <div class="red-row-label">Senior citizens</div>
                <div class="red-row-price" *ngIf="isPaidLocal">{{ +(event.eventFeeSeniorCitizen || 0) | currency:'USD' }}</div>
                <input type="number" min="0" class="form-control form-control-sm red-qty" [(ngModel)]="seniors"
                       [ngModelOptions]="{standalone: true}" aria-label="Senior citizens">
            </div>
            <div class="form-group mt-2" *ngIf="children > 0">
                <label class="small mb-1" for="red-ages">Children's ages</label>
                <input id="red-ages" type="text" class="form-control form-control-sm" [(ngModel)]="childAges"
                       [ngModelOptions]="{standalone: true}" placeholder="e.g. 4, 9">
            </div>
        </div>

        <div class="form-group mt-3">
            <label class="small mb-1" for="red-donation">Donation ($)</label>
            <input id="red-donation" type="number" min="0" class="form-control form-control-sm red-qty-wide"
                   [(ngModel)]="donation" [ngModelOptions]="{standalone: true}">
        </div>

        <!-- Built-in attending question: required of the registrant, optional for an organizer fixing someone else's -->
        <div class="form-group" *ngIf="usesLegacyAttending">
            <label class="small mb-1 d-block">Are you attending the conference?
                <span *ngIf="!isOrganizer" class="text-danger" title="Required">*</span>
            </label>
            <div class="form-check">
                <input type="radio" id="red-att-yes" name="red-attending" value="YES" [(ngModel)]="attending"
                       [ngModelOptions]="{standalone: true}">
                <label class="radio mb-0" for="red-att-yes">Yes</label>
            </div>
            <div class="form-check mt-1">
                <input type="radio" id="red-att-no" name="red-attending" value="NO" [(ngModel)]="attending"
                       [ngModelOptions]="{standalone: true}">
                <label class="radio mb-0" for="red-att-no">No</label>
            </div>
            <small class="text-danger d-block mt-1" *ngIf="showAttendingError">
                <i class="uil uil-exclamation-circle mr-1"></i>Please select an option.
            </small>
        </div>

        <!-- Organizer-defined questions -->
        <div *ngIf="questions.length > 0">
            <h6 class="mt-3">Registration questions</h6>
            <app-question-fields [questions]="questions" [answers]="answers" idPrefix="red"
                                 [showErrors]="submitAttempted" (answersChange)="answers = $event"></app-question-fields>
        </div>

        <!-- Estimate -->
        <div class="red-estimate" *ngIf="changed">
            New total (estimate): <strong>{{ estimatedTotal | currency:'USD' }}</strong>
            <span *ngIf="estimatedBalance > 0.004"> · balance <strong>{{ estimatedBalance | currency:'USD' }}</strong></span>
            <span *ngIf="estimatedBalance < -0.004"> · overpaid <strong>{{ -estimatedBalance | currency:'USD' }}</strong></span>
            <small class="d-block text-muted">The exact amount is worked out when you save (earlier prices and any early-bird discount are kept).</small>
        </div>

        <!-- Organizer: reason + payment -->
        <div *ngIf="isOrganizer" class="mt-3">
            <div class="form-group">
                <label class="small mb-1" for="red-reason">Reason for the change <span class="text-danger">*</span></label>
                <textarea id="red-reason" rows="2" class="form-control form-control-sm" [(ngModel)]="reason"
                          [ngModelOptions]="{standalone: true}" placeholder="Shown in the history and to the registrant"></textarea>
            </div>

            <label class="mb-0 d-block" for="red-record">
                <input id="red-record" type="checkbox" [(ngModel)]="recordPayment" (change)="onToggleRecordPayment()"
                       [ngModelOptions]="{standalone: true}">
                {{ isRefund ? 'Record a refund sent to the registrant' : 'Record a payment received now' }}
            </label>
            <div class="red-payment" *ngIf="recordPayment">
                <div class="form-row">
                    <div class="col-sm-4">
                        <label class="small mb-1" for="red-amt">{{ isRefund ? 'Amount refunded ($)' : 'Amount received ($)' }}</label>
                        <input id="red-amt" type="number" min="0" class="form-control form-control-sm"
                               [(ngModel)]="paymentAmount" (ngModelChange)="markAmountEdited()" [ngModelOptions]="{standalone: true}">
                    </div>
                    <div class="col-sm-4">
                        <label class="small mb-1" for="red-method">{{ isRefund ? 'Sent by' : 'Method' }}</label>
                        <select id="red-method" class="form-control form-control-sm" [(ngModel)]="paymentMethod"
                                [ngModelOptions]="{standalone: true}">
                            <option value="zelle">Zelle</option>
                            <option value="check">Check</option>
                            <option value="cash">Cash</option>
                            <option value="stripe">Card (Stripe)</option>
                        </select>
                    </div>
                    <div class="col-sm-4">
                        <label class="small mb-1" for="red-ref">Reference</label>
                        <input id="red-ref" type="text" class="form-control form-control-sm" [(ngModel)]="paymentReference"
                               [ngModelOptions]="{standalone: true}" placeholder="Check # / Zelle #">
                    </div>
                </div>
                <small class="text-muted d-block mt-2" *ngIf="isRefund">
                    This records a refund you have already sent. To refund a card payment through Stripe, use Finance &rarr; Payments.
                    <span *ngIf="!canWaive" class="text-danger">Only the chapter executive committee or NEC can record a refund.</span>
                </small>
                <label class="mt-2 mb-0 d-block" for="red-waive" *ngIf="!isRefund && canWaive && (paymentAmount || 0) < suggestedPayment - 0.004">
                    <input id="red-waive" type="checkbox" [(ngModel)]="waiveBalance" [ngModelOptions]="{standalone: true}">
                    Waive the remaining {{ suggestedPayment - (paymentAmount || 0) | currency:'USD' }} (no further payment expected)
                </label>
                <small class="text-muted d-block mt-1" *ngIf="!isRefund && !canWaive && (paymentAmount || 0) < suggestedPayment - 0.004">
                    The amount is less than the balance. Only the chapter executive committee or NEC can waive a remainder.
                </small>
            </div>
        </div>

        <!-- History -->
        <div class="mt-3">
            <button type="button" class="btn btn-link btn-sm p-0" (click)="toggleHistory()">
                {{ showHistory ? 'Hide' : 'Show' }} change history
            </button>
            <div *ngIf="showHistory" class="red-history">
                <p class="small text-muted mb-0" *ngIf="historyLoaded && history.length === 0">No changes recorded yet.</p>
                <div class="red-hist-item" *ngFor="let h of history">
                    <div class="small">
                        <strong>{{ h.action === 'EDIT' ? 'Edited' : (h.action === 'WAIVE' ? 'Balance waived' : (h.action === 'REFUND' ? 'Refund recorded' : (h.action === 'REOPEN' ? 'Moved back to pending' : (h.action === 'NO_SHOW' ? 'Marked didn\'t attend, no payment' : (h.action === 'RESTORE' ? 'Restored from no-show' : 'Payment confirmed'))))) }}</strong>
                        by {{ kindLabel(h.changedByKind) }} · {{ h.changedAt }}
                    </div>
                    <ul class="mb-1 small">
                        <li *ngFor="let c of h.changes">{{ c.field }}: {{ c.from || '-' }} &rarr; {{ c.to || '-' }}</li>
                    </ul>
                    <div class="small text-muted" *ngIf="h.reason">Reason: {{ h.reason }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="red-error" *ngIf="error" role="alert">{{ error }}</div>
    <div class="red-foot">
        <button type="button" class="btn btn-outline-warning btn-sm mr-auto" *ngIf="isOrganizer && isConfirmed"
                (click)="reopen()" [disabled]="saving"
                title="Set this registration back to Payment Pending so it can be changed; payments already recorded are kept">
            Move back to pending
        </button>
        <button type="button" class="btn btn-light btn-sm" (click)="close()" [disabled]="saving">Cancel</button>
        <button type="button" class="rana-action-btn rana-action-btn-success" (click)="save()" [disabled]="saving">
            {{ recordPayment && isOrganizer ? (isRefund ? 'Save & record refund' : 'Save & record payment') : 'Save changes' }}
        </button>
    </div>
</div>
